<template lang="pug">
  .find-a-replace-vehicle
    .container
      cards(:data="selectedDates")
      .row
        .columns

          label Start
            date-picker(v-model="bookRequest.start", :pickTime="true", :format="'yyyy-mm-dd hh:ii'", :initialDate="$dateFormat(initialStart,'YYYY-MM-DD HH:mm')")
        .columns
          label End
            date-picker(v-model="bookRequest.end", :pickTime="true", :format="'yyyy-mm-dd hh:ii'", :initialDate="$dateFormat(initialEnd,'YYYY-MM-DD HH:mm')")
      .row
        .column
          .text-right
            button.button.small(@click="search") Search
      .row.columns
        loading-spinner(v-if="loading" )
        .grouped.card(v-for="(slots, key) in slotsByLots", :style="gridStyle(slots)")
          h1.text-center {{key}}
          vehicle(v-for="vehicle in slots", :item="vehicle", type="search-result")
            .text-center
              button.button.small(type="button", @click="cancelAndBook(vehicle)") Cancel & Book
              span &nbsp;
              button.button.small(type="button", @click="voidAndBook(vehicle)") Void & Book
              button.button.small(@click="replaceVehicleSlot(vehicle)") Force replace vehicle slot

</template>

<script>
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import Vehicle from 'src/components/backoffice/Vehicle.vue'
import VehicleReplaceButtons from '../../../components/structure/ui/actions/VehicleReplaceButtons'
import MaggieHelper from '../../../maggieHelper'
import collect from 'collect.js'
import DatePicker from '../../../components/structure/DatePicker'
import Cards from '../../../components/structure/Cards'
import ActionButton from "../../../components/structure/ui/ActionButton";
import BookingModeSelect from "../../../components/structure/BookingModeSelect";
import LoadingAnimation from "../../../components/lib/LoadingAnimation.vue";
import LoadingSpinner from "../../../components/structure/LoadingSpinner.vue";

export default {
  name: 'FindAReplaceVehicle',
  components: {
    LoadingSpinner,
    LoadingAnimation, BookingModeSelect, ActionButton, Cards, DatePicker, VehicleReplaceButtons, Vehicle
  },
  props: ['item'],
  data() {
    return {
      vehicles: [],
      bookRequest: {
        plate: null,
        driver_id: null,
        start: null,
        end: null,
      },
      loading: false,
    }
  },
  mounted() {
    this.bookRequest.driver_id = this.item.driver.id
    this.bookRequest.start = this.initialStart
    this.bookRequest.end = this.initialEnd
    this.dataLoader()
  },
  methods: {
    search() {
      this.vehicles = []
      this.dataLoader()
    },
    cancelAndBook(item, confirmed = false) {
      if (!confirmed) {
        this.confirm('Cancel', item, this.cancelAndBook)
        return
      }
      this.bookRequest.plate = item.plate
      KeplerBackofficeSdk.reservations.select(this.item).cancel(() => {
        this.book()
      })
    },
    voidAndBook(item, confirmed = false) {
      if (!confirmed) {
        this.confirm('Cancel', item, this.voidAndBook)
        return
      }
      this.bookRequest.plate = item.plate
      KeplerBackofficeSdk.reservations.select(this.item).void(() => {
        this.book()
      })
    },
    replaceVehicleSlot(item, confirmed = false) {
      if (!confirmed) {
        this.confirm('hard replace', item, this.replaceVehicleSlot)
        return
      }
      KeplerBackofficeSdk.reservations.select(this.item)
        .replaceVehicleSlot({plate: item.plate}, (r) => {
          this.$router.push({name: 'reservation', params: {id: r.number}})
        })
    },
    dataLoader() {

      this.loading = true
      let latitude = this.item.vehicle.parking_lot.position.latitude;
      let longitude = this.item.vehicle.parking_lot.position.longitude;

      if (this.item.booking_mode === 'FF') {
        latitude = this.item.vehicle.position.latitude
        longitude = this.item.vehicle.position.longitude
      }

      KeplerBackofficeSdk.vehicleSlots.search({
        start: this.$dateFormat(this.bookRequest.start, 'X'),
        end: this.$dateFormat(this.bookRequest.end, 'X'),
        latitude: latitude,
        longitude: longitude,
      }, (data) => {
        var vehicles = data.map((item) => {
          item.vehicle['distance'] = parseFloat(item.distance / 1000).toFixed(2)
          return item.vehicle
        })
        this.vehicles = vehicles
        this.loading = false
      })
    },
    book() {
      this.bookRequest.start = parseInt(this.$dateFormat(this.bookRequest.start, 'X'))
      this.bookRequest.end = parseInt(this.$dateFormat(this.bookRequest.end, 'X'))
      KeplerBackofficeSdk.reservations.make(this.bookRequest, (r) => {
        MaggieHelper.notification('Create', 'New reservation created')
        this.$router.push({name: 'reservation', params: {id: r.number}})
      })
    },
    confirm(action, vehicle, callback) {
      this.$confirm('Are you sure?', `Do you really want to ${action} R${this.item.number} and book V${vehicle.id} - ${vehicle.brand} ${vehicle.model} ${vehicle.plate}`, () => {
        callback(vehicle, true)
      })
    },
    gridStyle(slots) {
      const auto = slots.length > 3 ? 'auto auto auto' : `repeat(${slots.length},auto)`
      return {
        gridTemplateColumns: auto
      }
    },
  },
  computed: {

    slotsByLots() {

      const c = collect(this.vehicles)
      return c.groupBy((item) => {
        return item.parking_lot.name
      }).all()
    },
    initialStart() {
      return this.item.status === 'STARTED' ? new Date() : new Date(this.item.start)
    },
    initialEnd() {
      return new Date(this.item.end)
    },
    selectedDates() {
      return [
        {
          title: 'Start',
          value: this.$dateFormat(this.item.start, this.$toMomentFormat(this.$configurationDateTimeFormat()))
        },
        {
          title: 'End',
          value: this.$dateFormat(this.item.end, this.$toMomentFormat(this.$configurationDateTimeFormat()))
        },
        {
          title: 'Vehicle',
          value: `${this.item.vehicle.brand} ${this.item.vehicle.model}<br>${this.item.vehicle.plate}`
        },
        {
          title: 'Parking lot',
          value: `${this.item.vehicle.parking_lot.name}`
        },
      ]

    }
  }
}
</script>

<style lang="sass">
.find-a-replace-vehicle
  .grouped
    display: grid
    //grid-template-columns: auto auto auto
    @media(max-width: 600px)
      grid-template-columns: auto !important

    h1
      grid-column: 1/-1

  .card-section
    h1
      font-size: 1.6em
</style>



// WEBPACK FOOTER //
// FindAReplaceVehicle.vue?520af614